export function routeAfterLogin(user) {
    if (user.type === 'Admin') return '/admin/companies'
    if (user.type === 'CompanyManager') return '/manager/programs'
    return '/participant/invites'
}

export function routeEnrollment(enrollment) {
    switch (enrollment.status) {
        case 'PendingQuestionnaire': return `/participant/enrollment/${enrollment.enrollmentId}/questionnaire`
        case 'MatchConfirmed': return `/participant/enrollment/${enrollment.enrollmentId}/dashboard`
        default: return `/participant/enrollment/${enrollment.enrollmentId}/matching`
    }
}